export default { sha: '1438c550657d1f92fa400b7a7a4c1a3b6e559a92', buildNumber: 'undefined' }
